import { Component, Input, OnChanges, OnInit } from '@angular/core'

@Component({
  standalone: false,
  selector: 'app-pop-up',
  templateUrl: './pop-up.component.html',
  styleUrls: ['./pop-up.component.scss']
})
export class PopUpComponent implements OnInit, OnChanges {
  isShow: boolean = true
  @Input('backdrop') backdrop: boolean = true
  @Input() id: any
  idElement: any
  constructor() {}

  ngOnInit() {}
  
  show() {
    this.isShow = true
  }

  hide() {
    this.isShow = false
  }

  ngOnChanges() {
    if (this.id) {
      this.idElement = this.id;
    }
  }
}
